import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const astro = css`


@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>


@layer properties {
    @supports (((-webkit-hyphens: none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))) {
        *, :before, :after, ::backdrop {
            --tw-translate-x:0;
            --tw-translate-y: 0;
            --tw-translate-z: 0;
            --tw-rotate-x: initial;
            --tw-rotate-y: initial;
            --tw-rotate-z: initial;
            --tw-skew-x: initial;
            --tw-skew-y: initial;
            --tw-space-y-reverse: 0;
            --tw-divide-y-reverse: 0;
            --tw-border-style: solid;
            --tw-gradient-position: initial;
            --tw-gradient-from: #0000;
            --tw-gradient-via: #0000;
            --tw-gradient-to: #0000;
            --tw-gradient-stops: initial;
            --tw-gradient-via-stops: initial;
            --tw-gradient-from-position: 0%;
            --tw-gradient-via-position: 50%;
            --tw-gradient-to-position: 100%;
            --tw-leading: initial;
            --tw-font-weight: initial;
            --tw-tracking: initial;
            --tw-shadow: 0 0 #0000;
            --tw-shadow-color: initial;
            --tw-shadow-alpha: 100%;
            --tw-inset-shadow: 0 0 #0000;
            --tw-inset-shadow-color: initial;
            --tw-inset-shadow-alpha: 100%;
            --tw-ring-color: initial;
            --tw-ring-shadow: 0 0 #0000;
            --tw-inset-ring-color: initial;
            --tw-inset-ring-shadow: 0 0 #0000;
            --tw-ring-inset: initial;
            --tw-ring-offset-width: 0px;
            --tw-ring-offset-color: #fff;
            --tw-ring-offset-shadow: 0 0 #0000;
            --tw-outline-style: solid;
            --tw-blur: initial;
            --tw-brightness: initial;
            --tw-contrast: initial;
            --tw-grayscale: initial;
            --tw-hue-rotate: initial;
            --tw-invert: initial;
            --tw-opacity: initial;
            --tw-saturate: initial;
            --tw-sepia: initial;
            --tw-drop-shadow: initial;
            --tw-drop-shadow-color: initial;
            --tw-drop-shadow-alpha: 100%;
            --tw-drop-shadow-size: initial;
            --tw-backdrop-blur: initial;
            --tw-backdrop-brightness: initial;
            --tw-backdrop-contrast: initial;
            --tw-backdrop-grayscale: initial;
            --tw-backdrop-hue-rotate: initial;
            --tw-backdrop-invert: initial;
            --tw-backdrop-opacity: initial;
            --tw-backdrop-saturate: initial;
            --tw-backdrop-sepia: initial;
            --tw-duration: initial;
            --tw-ease: initial;
            --tw-scale-x: 1;
            --tw-scale-y: 1;
            --tw-scale-z: 1
        }
    }
}

@layer theme {
    :root,
    :host {
        --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        --color-red-50: oklch(97.1% .013 17.38);
        --color-red-100: oklch(93.6% .032 17.717);
        --color-red-300: oklch(80.8% .114 19.571);
        --color-red-400: oklch(70.4% .191 22.216);
        --color-red-500: oklch(63.7% .237 25.331);
        --color-red-600: oklch(57.7% .245 27.325);
        --color-red-700: oklch(50.5% .213 27.518);
        --color-red-800: oklch(44.4% .177 26.899);
        --color-red-900: oklch(39.6% .141 25.723);
        --color-amber-50: oklch(98.7% .022 95.277);
        --color-amber-100: oklch(96.2% .059 95.617);
        --color-amber-300: oklch(87.9% .169 91.605);
        --color-amber-400: oklch(82.8% .189 84.429);
        --color-amber-500: oklch(76.9% .188 70.08);
        --color-amber-600: oklch(66.6% .179 58.318);
        --color-amber-700: oklch(55.5% .163 48.998);
        --color-amber-800: oklch(47.3% .137 46.201);
        --color-amber-900: oklch(41.4% .112 45.904);
        --color-green-50: oklch(98.2% .018 155.826);
        --color-green-100: oklch(96.2% .044 156.743);
        --color-green-300: oklch(87.1% .15 154.449);
        --color-green-400: oklch(79.2% .209 151.711);
        --color-green-500: oklch(72.3% .219 149.579);
        --color-green-600: oklch(62.7% .194 149.214);
        --color-green-700: oklch(52.7% .154 150.069);
        --color-green-800: oklch(44.8% .119 151.328);
        --color-green-900: oklch(39.3% .095 152.535);
        --color-blue-50: oklch(97% .014 254.604);
        --color-blue-100: oklch(93.2% .032 255.585);
        --color-blue-300: oklch(80.9% .105 251.813);
        --color-blue-400: oklch(70.7% .165 254.624);
        --color-blue-500: oklch(62.3% .214 259.815);
        --color-blue-600: oklch(54.6% .245 262.881);
        --color-blue-700: oklch(48.8% .243 264.376);
        --color-blue-800: oklch(42.4% .199 265.638);
        --color-blue-900: oklch(37.9% .146 265.522);
        --color-black: #000;
        --color-white: #fff;
        --spacing: .25rem;
        --container-xs: 20rem;
        --container-sm: 24rem;
        --container-lg: 32rem;
        --container-xl: 36rem;
        --container-2xl: 42rem;
        --container-3xl: 48rem;
        --container-4xl: 56rem;
        --container-5xl: 64rem;
        --container-7xl: 80rem;
        --text-xs: .75rem;
        --text-xs--line-height: calc(1 / .75);
        --text-sm: .875rem;
        --text-sm--line-height: calc(1.25 / .875);
        --text-base: 1rem;
        --text-base--line-height: 1.5;
        --text-lg: 1.125rem;
        --text-lg--line-height: calc(1.75 / 1.125);
        --text-xl: 1.25rem;
        --text-xl--line-height: calc(1.75 / 1.25);
        --text-2xl: 1.5rem;
        --text-2xl--line-height: calc(2 / 1.5);
        --text-3xl: 1.875rem;
        --text-3xl--line-height: 1.2;
        --text-4xl: 2.25rem;
        --text-4xl--line-height: calc(2.5 / 2.25);
        --text-5xl: 3rem;
        --text-5xl--line-height: 1;
        --text-6xl: 3.75rem;
        --text-6xl--line-height: 1;
        --text-8xl: 6rem;
        --text-8xl--line-height: 1;
        --text-9xl: 8rem;
        --text-9xl--line-height: 1;
        --font-weight-normal: 400;
        --font-weight-medium: 500;
        --font-weight-semibold: 600;
        --font-weight-bold: 700;
        --tracking-tight: -.025em;
        --tracking-wider: .05em;
        --leading-relaxed: 1.625;
        --radius-lg: .5rem;
        --radius-xl: .75rem;
        --radius-2xl: 1rem;
        --ease-out: cubic-bezier(0, 0, .2, 1);
        --animate-spin: spin 1s linear infinite;
        --animate-ping: ping 1s cubic-bezier(0, 0, .2, 1) infinite;
        --blur-sm: 8px;
        --blur-lg: 16px;
        --blur-3xl: 64px;
        --aspect-video: 16 / 9;
        --default-transition-duration: .15s;
        --default-transition-timing-function: cubic-bezier(.4, 0, .2, 1);
        --default-mono-font-family: var(--font-mono)
    }
}

@layer base {
    *,
    :after,
    :before,
    ::backdrop {
        box-sizing: border-box;
        border: 0 solid;
        margin: 0;
        padding: 0
    }
    ::file-selector-button {
        box-sizing: border-box;
        border: 0 solid;
        margin: 0;
        padding: 0
    }
    html,
    :host {
        -webkit-text-size-adjust: 100%;
        tab-size: 4;
        font-feature-settings: normal;
        font-variation-settings: normal;
        -webkit-tap-highlight-color: transparent;
        font-family: Plus Jakarta Sans, system-ui, sans-serif;
        line-height: 1.5
    }
    hr {
        height: 0;
        color: inherit;
        border-top-width: 1px
    }
    abbr:where([title]) {
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: inherit;
        font-weight: inherit
    }
    a {
        color: inherit;
        -webkit-text-decoration: inherit;
        text-decoration: inherit
    }
    b,
    strong {
        font-weight: bolder
    }
    code,
    kbd,
    samp,
    pre {
        font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
        font-feature-settings: var(--default-mono-font-feature-settings, normal);
        font-variation-settings: var(--default-mono-font-variation-settings, normal);
        font-size: 1em
    }
    small {
        font-size: 80%
    }
    sub,
    sup {
        vertical-align: baseline;
        font-size: 75%;
        line-height: 0;
        position: relative
    }
    sub {
        bottom: -.25em
    }
    sup {
        top: -.5em
    }
    table {
        text-indent: 0;
        border-color: inherit;
        border-collapse: collapse
    }
    :-moz-focusring {
        outline: auto
    }
    progress {
        vertical-align: baseline
    }
    summary {
        display: list-item
    }
    ol,
    ul,
    menu {
        list-style: none
    }
    img,
    svg,
    video,
    canvas,
    audio,
    iframe,
    embed,
    object {
        vertical-align: middle;
        display: block
    }
    img,
    video {
        max-width: 100%;
        height: auto
    }
    button,
    input,
    select,
    optgroup,
    textarea {
        font: inherit;
        font-feature-settings: inherit;
        font-variation-settings: inherit;
        letter-spacing: inherit;
        color: inherit;
        opacity: 1;
        background-color: #0000;
        border-radius: 0
    }
    ::file-selector-button {
        font: inherit;
        font-feature-settings: inherit;
        font-variation-settings: inherit;
        letter-spacing: inherit;
        color: inherit;
        opacity: 1;
        background-color: #0000;
        border-radius: 0
    }
    :where(select:is([multiple], [size])) optgroup {
        font-weight: bolder
    }
    :where(select:is([multiple], [size])) optgroup option {
        padding-inline-start: 20px
    }
    ::file-selector-button {
        margin-inline-end: 4px
    }
    ::placeholder {
        opacity: 1
    }
    @supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px) {
        ::placeholder {
            color: currentColor
        }
        @supports (color:color-mix(in lab, red, red)) {
            ::placeholder {
                color: color-mix(in oklab, currentcolor 50%, transparent)
            }
        }
    }
    textarea {
        resize: vertical
    }
    ::-webkit-search-decoration {
        -webkit-appearance: none
    }
    ::-webkit-date-and-time-value {
        min-height: 1lh;
        text-align: inherit
    }
    ::-webkit-datetime-edit {
        display: inline-flex
    }
    ::-webkit-datetime-edit-fields-wrapper {
        padding: 0
    }
    ::-webkit-datetime-edit {
        padding-block: 0
    }
    ::-webkit-datetime-edit-year-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-month-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-day-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-hour-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-minute-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-second-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-millisecond-field {
        padding-block: 0
    }
    ::-webkit-datetime-edit-meridiem-field {
        padding-block: 0
    }
    ::-webkit-calendar-picker-indicator {
        line-height: 1
    }
    :-moz-ui-invalid {
        box-shadow: none
    }
    button,
    input:where([type=button], [type=reset], [type=submit]) {
        appearance: button
    }
    ::file-selector-button {
        appearance: button
    }
    ::-webkit-inner-spin-button {
        height: auto
    }
    ::-webkit-outer-spin-button {
        height: auto
    }
    [hidden]:where(:not([hidden=until-found])) {
        display: none !important
    }
    html {
        scroll-behavior: smooth
    }
    body {
        background-color: var(--color-white);
        color: #111827;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale
    }
    body:is(.dark *) {
        color: #f3f4f6;
        background-color: #030712
    }
    :focus-visible {
        outline-style: var(--tw-outline-style);
        outline-offset: 2px;
        outline-width: 2px;
        outline-color: #f59e0b
    }
}

@layer components {
    .btn {
        justify-content: center;
        align-items: center;
        gap: calc(var(--spacing) * 2);
        border-radius: var(--radius-lg);
        padding-inline: calc(var(--spacing) * 5);
        padding-block: calc(var(--spacing) * 2.5);
        font-size: var(--text-sm);
        line-height: var(--tw-leading, var(--text-sm--line-height));
        --tw-font-weight: var(--font-weight-medium);
        font-weight: var(--font-weight-medium);
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration));
        display: inline-flex
    }
    .btn:focus {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-offset-width: 2px;
        --tw-ring-offset-shadow: var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-outline-style: none;
        outline-style: none
    }
    .btn-primary {
        justify-content: center;
        align-items: center;
        gap: calc(var(--spacing) * 2);
        border-radius: var(--radius-lg);
        padding-inline: calc(var(--spacing) * 5);
        padding-block: calc(var(--spacing) * 2.5);
        font-size: var(--text-sm);
        line-height: var(--tw-leading, var(--text-sm--line-height));
        --tw-font-weight: var(--font-weight-medium);
        font-weight: var(--font-weight-medium);
        color: var(--color-white);
        --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, #0000001a), 0 4px 6px -4px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-shadow-color: #d9770640;
        background-color: #d97706;
        display: inline-flex
    }
    @supports (color:color-mix(in lab, red, red)) {
        .btn-primary {
            --tw-shadow-color: color-mix(in oklab, oklab(66.584% .082678 .133963/.25) var(--tw-shadow-alpha), transparent)
        }
    }
    .btn-primary {
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    @media(hover:hover) {
        .btn-primary:hover {
            --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, #0000001a), 0 8px 10px -6px var(--tw-shadow-color, #0000001a);
            box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
            --tw-shadow-color: #d977064d;
            background-color: #b45309
        }
        @supports (color:color-mix(in lab, red, red)) {
            .btn-primary:hover {
                --tw-shadow-color: color-mix(in oklab, oklab(66.584% .082678 .133963/.3) var(--tw-shadow-alpha), transparent)
            }
        }
    }
    .btn-primary:focus {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: #f59e0b;
        --tw-ring-offset-width: 2px;
        --tw-ring-offset-shadow: var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-outline-style: none;
        outline-style: none
    }
    .btn-secondary {
        justify-content: center;
        align-items: center;
        gap: calc(var(--spacing) * 2);
        border-radius: var(--radius-lg);
        border-style: var(--tw-border-style);
        background-color: var(--color-white);
        padding-inline: calc(var(--spacing) * 5);
        padding-block: calc(var(--spacing) * 2.5);
        font-size: var(--text-sm);
        line-height: var(--tw-leading, var(--text-sm--line-height));
        --tw-font-weight: var(--font-weight-medium);
        font-weight: var(--font-weight-medium);
        color: #374151;
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration));
        border-width: 1px;
        border-color: #d1d5db;
        display: inline-flex
    }
    @media(hover:hover) {
        .btn-secondary:hover {
            background-color: #f9fafb
        }
    }
    .btn-secondary:focus {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
        --tw-ring-color: #6b7280;
        --tw-ring-offset-width: 2px;
        --tw-ring-offset-shadow: var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-outline-style: none;
        outline-style: none
    }
    .btn-secondary:is(.dark *) {
        color: #d1d5db;
        background-color: #111827;
        border-color: #374151
    }
    @media(hover:hover) {
        .btn-secondary:is(.dark *):hover {
            background-color: #1f2937
        }
    }
    .card {
        border-radius: var(--radius-2xl);
        background-color: var(--color-white);
        padding: calc(var(--spacing) * 6);
        transition-property: box-shadow;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .card:is(.dark *) {
        background-color: #111827
    }
    .card {
        box-shadow: 0 4px 16px -4px #0000001a
    }
    .card:hover {
        box-shadow: 0 12px 32px -8px #00000024
    }
    .section {
        padding-block: calc(var(--spacing) * 20)
    }
    @media(min-width:64rem) {
        .section {
            padding-block: calc(var(--spacing) * 28)
        }
    }
    .container-narrow {
        max-width: var(--container-5xl);
        padding-inline: calc(var(--spacing) * 4);
        margin-inline: auto
    }
    @media(min-width:64rem) {
        .container-narrow {
            padding-inline: calc(var(--spacing) * 8)
        }
    }
}

@layer utilities {
    .invisible {
        visibility: hidden
    }
    .visible {
        visibility: visible
    }
    .sr-only {
        clip-path: inset(50%);
        white-space: nowrap;
        border-width: 0;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        position: absolute;
        overflow: hidden
    }
    .absolute {
        position: absolute
    }
    .fixed {
        position: fixed
    }
    .relative {
        position: relative
    }
    .static {
        position: static
    }
    .sticky {
        position: sticky
    }
    .inset-0 {
        inset: calc(var(--spacing) * 0)
    }
    .start {
        inset-inline-start: var(--spacing)
    }
    .end {
        inset-inline-end: var(--spacing)
    }
    .-top-4 {
        top: calc(var(--spacing) * -4)
    }
    .-top-12 {
        top: calc(var(--spacing) * -12)
    }
    .-top-20 {
        top: calc(var(--spacing) * -20)
    }
    .-top-40 {
        top: calc(var(--spacing) * -40)
    }
    .top-0 {
        top: calc(var(--spacing) * 0)
    }
    .top-0\\.5 {
        top: calc(var(--spacing) * .5)
    }
    .top-1 {
        top: calc(var(--spacing) * 1)
    }
    .top-1\\/2 {
        top: 50%
    }
    .top-4 {
        top: calc(var(--spacing) * 4)
    }
    .top-6 {
        top: calc(var(--spacing) * 6)
    }
    .top-full {
        top: 100%
    }
    .-right-4 {
        right: calc(var(--spacing) * -4)
    }
    .-right-20 {
        right: calc(var(--spacing) * -20)
    }
    .right-0 {
        right: calc(var(--spacing) * 0)
    }
    .right-4 {
        right: calc(var(--spacing) * 4)
    }
    .right-6 {
        right: calc(var(--spacing) * 6)
    }
    .-bottom-20 {
        bottom: calc(var(--spacing) * -20)
    }
    .bottom-0 {
        bottom: calc(var(--spacing) * 0)
    }
    .bottom-6 {
        bottom: calc(var(--spacing) * 6)
    }
    .-left-4 {
        left: calc(var(--spacing) * -4)
    }
    .-left-20 {
        left: calc(var(--spacing) * -20)
    }
    .left-0 {
        left: calc(var(--spacing) * 0)
    }
    .left-0\\.5 {
        left: calc(var(--spacing) * .5)
    }
    .left-1 {
        left: calc(var(--spacing) * 1)
    }
    .left-1\\/2 {
        left: 50%
    }
    .left-4 {
        left: calc(var(--spacing) * 4)
    }
    .-z-10 {
        z-index: -10
    }
    .z-0 {
        z-index: 0
    }
    .z-10 {
        z-index: 10
    }
    .z-40 {
        z-index: 40
    }
    .z-50 {
        z-index: 50
    }
    .z-\\[60\\] {
        z-index: 60
    }
    .z-\\[70\\] {
        z-index: 70
    }
    .z-\\[80\\] {
        z-index: 80
    }
    .z-\\[100\\] {
        z-index: 100
    }
    .order-last {
        order: 9999
    }
    .col-span-full {
        grid-column: 1/-1
    }
    .container {
        width: 100%
    }
    @media(min-width:475px) {
        .container {
            max-width: 475px
        }
    }
    @media(min-width:1920px) {
        .container {
            max-width: 1920px
        }
    }
    @media(min-width:40rem) {
        .container {
            max-width: 40rem
        }
    }
    @media(min-width:48rem) {
        .container {
            max-width: 48rem
        }
    }
    @media(min-width:64rem) {
        .container {
            max-width: 64rem
        }
    }
    @media(min-width:80rem) {
        .container {
            max-width: 80rem
        }
    }
    @media(min-width:96rem) {
        .container {
            max-width: 96rem
        }
    }
    .container {
        margin-inline: auto;
        padding-inline: 1rem
    }
    @media(min-width:40rem) {
        .container {
            padding-inline: 1.5rem
        }
    }
    @media(min-width:64rem) {
        .container {
            padding-inline: 2rem
        }
    }
    @media(min-width:80rem) {
        .container {
            padding-inline: 2.5rem
        }
    }
    @media(min-width:96rem) {
        .container {
            padding-inline: 3rem
        }
    }
    .mx-auto {
        margin-inline: auto
    }
    .my-16 {
        margin-block: calc(var(--spacing) * 16)
    }
    .-mt-1 {
        margin-top: calc(var(--spacing) * -1)
    }
    .mt-0\\.5 {
        margin-top: calc(var(--spacing) * .5)
    }
    .mt-1 {
        margin-top: calc(var(--spacing) * 1)
    }
    .mt-1\\.5 {
        margin-top: calc(var(--spacing) * 1.5)
    }
    .mt-2 {
        margin-top: calc(var(--spacing) * 2)
    }
    .mt-3 {
        margin-top: calc(var(--spacing) * 3)
    }
    .mt-4 {
        margin-top: calc(var(--spacing) * 4)
    }
    .mt-5 {
        margin-top: calc(var(--spacing) * 5)
    }
    .mt-6 {
        margin-top: calc(var(--spacing) * 6)
    }
    .mt-8 {
        margin-top: calc(var(--spacing) * 8)
    }
    .mt-10 {
        margin-top: calc(var(--spacing) * 10)
    }
    .mt-12 {
        margin-top: calc(var(--spacing) * 12)
    }
    .mt-16 {
        margin-top: calc(var(--spacing) * 16)
    }
    .mb-2 {
        margin-bottom: calc(var(--spacing) * 2)
    }
    .mb-3 {
        margin-bottom: calc(var(--spacing) * 3)
    }
    .mb-4 {
        margin-bottom: calc(var(--spacing) * 4)
    }
    .mb-6 {
        margin-bottom: calc(var(--spacing) * 6)
    }
    .mb-8 {
        margin-bottom: calc(var(--spacing) * 8)
    }
    .mb-10 {
        margin-bottom: calc(var(--spacing) * 10)
    }
    .ml-0\\.5 {
        margin-left: calc(var(--spacing) * .5)
    }
    .ml-1 {
        margin-left: calc(var(--spacing) * 1)
    }
    .ml-1\\.5 {
        margin-left: calc(var(--spacing) * 1.5)
    }
    .ml-2 {
        margin-left: calc(var(--spacing) * 2)
    }
    .ml-4 {
        margin-left: calc(var(--spacing) * 4)
    }
    .line-clamp-2 {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        overflow: hidden
    }
    .block {
        display: block
    }
    .flex {
        display: flex
    }
    .grid {
        display: grid
    }
    .hidden {
        display: none
    }
    .inline {
        display: inline
    }
    .inline-block {
        display: inline-block
    }
    .inline-flex {
        display: inline-flex
    }
    .table {
        display: table
    }
    .aspect-\\[3\\/2\\] {
        aspect-ratio: 3/2
    }
    .aspect-video {
        aspect-ratio: var(--aspect-video)
    }
    .h-0\\.5 {
        height: calc(var(--spacing) * .5)
    }
    .h-2 {
        height: calc(var(--spacing) * 2)
    }
    .h-2\\.5 {
        height: calc(var(--spacing) * 2.5)
    }
    .h-4 {
        height: calc(var(--spacing) * 4)
    }
    .h-4\\.5 {
        height: calc(var(--spacing) * 4.5)
    }
    .h-5 {
        height: calc(var(--spacing) * 5)
    }
    .h-6 {
        height: calc(var(--spacing) * 6)
    }
    .h-7 {
        height: calc(var(--spacing) * 7)
    }
    .h-8 {
        height: calc(var(--spacing) * 8)
    }
    .h-10 {
        height: calc(var(--spacing) * 10)
    }
    .h-12 {
        height: calc(var(--spacing) * 12)
    }
    .h-14 {
        height: calc(var(--spacing) * 14)
    }
    .h-16 {
        height: calc(var(--spacing) * 16)
    }
    .h-40 {
        height: calc(var(--spacing) * 40)
    }
    .h-56 {
        height: calc(var(--spacing) * 56)
    }
    .h-64 {
        height: calc(var(--spacing) * 64)
    }
    .h-80 {
        height: calc(var(--spacing) * 80)
    }
    .h-\\[400px\\] {
        height: 400px
    }
    .h-\\[500px\\] {
        height: 500px
    }
    .h-auto {
        height: auto
    }
    .h-full {
        height: 100%
    }
    .max-h-\\[90vh\\] {
        max-height: 90vh
    }
    .min-h-\\[60vh\\] {
        min-height: 60vh
    }
    .min-h-screen {
        min-height: 100vh
    }
    .w-2 {
        width: calc(var(--spacing) * 2)
    }
    .w-2\\.5 {
        width: calc(var(--spacing) * 2.5)
    }
    .w-4 {
        width: calc(var(--spacing) * 4)
    }
    .w-4\\.5 {
        width: calc(var(--spacing) * 4.5)
    }
    .w-5 {
        width: calc(var(--spacing) * 5)
    }
    .w-6 {
        width: calc(var(--spacing) * 6)
    }
    .w-7 {
        width: calc(var(--spacing) * 7)
    }
    .w-8 {
        width: calc(var(--spacing) * 8)
    }
    .w-10 {
        width: calc(var(--spacing) * 10)
    }
    .w-11 {
        width: calc(var(--spacing) * 11)
    }
    .w-12 {
        width: calc(var(--spacing) * 12)
    }
    .w-14 {
        width: calc(var(--spacing) * 14)
    }
    .w-40 {
        width: calc(var(--spacing) * 40)
    }
    .w-64 {
        width: calc(var(--spacing) * 64)
    }
    .w-\\[400px\\] {
        width: 400px
    }
    .w-\\[500px\\] {
        width: 500px
    }
    .w-auto {
        width: auto
    }
    .w-full {
        width: 100%
    }
    .max-w-2xl {
        max-width: var(--container-2xl)
    }
    .max-w-3xl {
        max-width: var(--container-3xl)
    }
    .max-w-4xl {
        max-width: var(--container-4xl)
    }
    .max-w-5xl {
        max-width: var(--container-5xl)
    }
    .max-w-7xl {
        max-width: var(--container-7xl)
    }
    .max-w-\\[90vw\\] {
        max-width: 90vw
    }
    .max-w-lg {
        max-width: var(--container-lg)
    }
    .max-w-none {
        max-width: none
    }
    .max-w-sm {
        max-width: var(--container-sm)
    }
    .max-w-xl {
        max-width: var(--container-xl)
    }
    .max-w-xs {
        max-width: var(--container-xs)
    }
    .min-w-0 {
        min-width: calc(var(--spacing) * 0)
    }
    .min-w-48 {
        min-width: calc(var(--spacing) * 48)
    }
    .flex-1 {
        flex: 1
    }
    .flex-shrink-0,
    .shrink-0 {
        flex-shrink: 0
    }
    .grow {
        flex-grow: 1
    }
    .border-collapse {
        border-collapse: collapse
    }
    .-translate-x-1\\/2 {
        --tw-translate-x: -50%;
        translate: var(--tw-translate-x) var(--tw-translate-y)
    }
    .-translate-y-1\\/2 {
        --tw-translate-y: -50%;
        translate: var(--tw-translate-x) var(--tw-translate-y)
    }
    .rotate-180 {
        rotate: 180deg
    }
    .transform {
        transform: var(--tw-rotate-x, ) var(--tw-rotate-y, ) var(--tw-rotate-z, ) var(--tw-skew-x, ) var(--tw-skew-y, )
    }
    .animate-ping {
        animation: var(--animate-ping)
    }
    .animate-spin {
        animation: var(--animate-spin)
    }
    .cursor-not-allowed {
        cursor: not-allowed
    }
    .cursor-pointer {
        cursor: pointer
    }
    .resize {
        resize: both
    }
    .list-decimal {
        list-style-type: decimal
    }
    .list-disc {
        list-style-type: disc
    }
    .grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
    .flex-col {
        flex-direction: column
    }
    .flex-wrap {
        flex-wrap: wrap
    }
    .items-baseline {
        align-items: baseline
    }
    .items-center {
        align-items: center
    }
    .items-start {
        align-items: flex-start
    }
    .justify-between {
        justify-content: space-between
    }
    .justify-center {
        justify-content: center
    }
    .gap-1 {
        gap: calc(var(--spacing) * 1)
    }
    .gap-2 {
        gap: calc(var(--spacing) * 2)
    }
    .gap-2\\.5 {
        gap: calc(var(--spacing) * 2.5)
    }
    .gap-3 {
        gap: calc(var(--spacing) * 3)
    }
    .gap-4 {
        gap: calc(var(--spacing) * 4)
    }
    .gap-6 {
        gap: calc(var(--spacing) * 6)
    }
    .gap-8 {
        gap: calc(var(--spacing) * 8)
    }
    .gap-12 {
        gap: calc(var(--spacing) * 12)
    }
    :where(.space-y-2>:not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)))
    }
    :where(.space-y-2\\.5>:not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 2.5) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 2.5) * calc(1 - var(--tw-space-y-reverse)))
    }
    :where(.space-y-3>:not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)))
    }
    :where(.space-y-4>:not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)))
    }
    :where(.space-y-6>:not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)))
    }
    :where(.space-y-8>:not(:last-child)) {
        --tw-space-y-reverse: 0;
        margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
        margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)))
    }
    :where(.divide-y>:not(:last-child)) {
        --tw-divide-y-reverse: 0;
        border-bottom-style: var(--tw-border-style);
        border-top-style: var(--tw-border-style);
        border-top-width: calc(1px * var(--tw-divide-y-reverse));
        border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)))
    }
    :where(.divide-gray-200>:not(:last-child)) {
        border-color: #e5e7eb
    }
    .overflow-hidden {
        overflow: hidden
    }
    .overflow-x-auto {
        overflow-x: auto
    }
    .rounded {
        border-radius: .25rem
    }
    .rounded-2xl {
        border-radius: var(--radius-2xl)
    }
    .rounded-full {
        border-radius: 3.40282e38px
    }
    .rounded-lg {
        border-radius: var(--radius-lg)
    }
    .rounded-xl {
        border-radius: var(--radius-xl)
    }
    .rounded-b-lg {
        border-bottom-right-radius: var(--radius-lg);
        border-bottom-left-radius: var(--radius-lg)
    }
    .border {
        border-style: var(--tw-border-style);
        border-width: 1px
    }
    .border-0 {
        border-style: var(--tw-border-style);
        border-width: 0
    }
    .border-2 {
        border-style: var(--tw-border-style);
        border-width: 2px
    }
    .border-4 {
        border-style: var(--tw-border-style);
        border-width: 4px
    }
    .border-y {
        border-block-style: var(--tw-border-style);
        border-block-width: 1px
    }
    .border-t {
        border-top-style: var(--tw-border-style);
        border-top-width: 1px
    }
    .border-t-0 {
        border-top-style: var(--tw-border-style);
        border-top-width: 0
    }
    .border-b {
        border-bottom-style: var(--tw-border-style);
        border-bottom-width: 1px
    }
    .border-b-2 {
        border-bottom-style: var(--tw-border-style);
        border-bottom-width: 2px
    }
    .border-l-4 {
        border-left-style: var(--tw-border-style);
        border-left-width: 4px
    }
    .\\ !border-red-500 {
        border-color: var(--color-red-500) !important
    }
    .border-amber-500 {
        border-color: var(--color-amber-500)
    }
    .border-blue-500 {
        border-color: var(--color-blue-500)
    }
    .border-gray-100 {
        border-color: #f3f4f6
    }
    .border-gray-200 {
        border-color: #e5e7eb
    }
    .border-gray-300 {
        border-color: #d1d5db
    }
    .border-gray-700 {
        border-color: #374151
    }
    .border-gray-800 {
        border-color: #1f2937
    }
    .border-green-500 {
        border-color: var(--color-green-500)
    }
    .border-primary-200 {
        border-color: #fde68a
    }
    .border-primary-600 {
        border-color: #d97706
    }
    .border-red-500 {
        border-color: var(--color-red-500)
    }
    .border-transparent {
        border-color: #0000
    }
    .border-white\\/30 {
        border-color: #ffffff4d
    }
    @supports (color:color-mix(in lab, red, red)) {
        .border-white\\/30 {
            border-color: color-mix(in oklab, var(--color-white) 30%, transparent)
        }
    }
    .border-t-primary-600 {
        border-top-color: #d97706
    }
    .bg-amber-50 {
        background-color: var(--color-amber-50)
    }
    .bg-amber-100 {
        background-color: var(--color-amber-100)
    }
    .bg-black {
        background-color: var(--color-black)
    }
    .bg-black\\/50 {
        background-color: #00000080
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-black\\/50 {
            background-color: color-mix(in oklab, var(--color-black) 50%, transparent)
        }
    }
    .bg-black\\/80 {
        background-color: #000c
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-black\\/80 {
            background-color: color-mix(in oklab, var(--color-black) 80%, transparent)
        }
    }
    .bg-black\\/90 {
        background-color: #000000e6
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-black\\/90 {
            background-color: color-mix(in oklab, var(--color-black) 90%, transparent)
        }
    }
    .bg-blue-50 {
        background-color: var(--color-blue-50)
    }
    .bg-blue-100 {
        background-color: var(--color-blue-100)
    }
    .bg-gray-50 {
        background-color: #f9fafb
    }
    .bg-gray-50\\/50 {
        background-color: #f9fafb80
    }
    .bg-gray-100 {
        background-color: #f3f4f6
    }
    .bg-gray-200 {
        background-color: #e5e7eb
    }
    .bg-gray-300 {
        background-color: #d1d5db
    }
    .bg-gray-800 {
        background-color: #1f2937
    }
    .bg-gray-900 {
        background-color: #111827
    }
    .bg-green-50 {
        background-color: var(--color-green-50)
    }
    .bg-green-100 {
        background-color: var(--color-green-100)
    }
    .bg-green-600 {
        background-color: var(--color-green-600)
    }
    .bg-primary-50 {
        background-color: #fffbeb
    }
    .bg-primary-100 {
        background-color: #fef3c7
    }
    .bg-primary-100\\/40 {
        background-color: #fef3c766
    }
    .bg-primary-200\\/50 {
        background-color: #fde68a80
    }
    .bg-primary-400 {
        background-color: #fbbf24
    }
    .bg-primary-500 {
        background-color: #f59e0b
    }
    .bg-primary-600 {
        background-color: #d97706
    }
    .bg-primary-600\\/20 {
        background-color: #d9770633
    }
    .bg-red-50 {
        background-color: var(--color-red-50)
    }
    .bg-red-100 {
        background-color: var(--color-red-100)
    }
    .bg-red-600 {
        background-color: var(--color-red-600)
    }
    .bg-white {
        background-color: var(--color-white)
    }
    .bg-white\\/10 {
        background-color: #ffffff1a
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-white\\/10 {
            background-color: color-mix(in oklab, var(--color-white) 10%, transparent)
        }
    }
    .bg-white\\/20 {
        background-color: #fff3
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-white\\/20 {
            background-color: color-mix(in oklab, var(--color-white) 20%, transparent)
        }
    }
    .bg-white\\/80 {
        background-color: #fffc
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-white\\/80 {
            background-color: color-mix(in oklab, var(--color-white) 80%, transparent)
        }
    }
    .bg-white\\/90 {
        background-color: #ffffffe6
    }
    @supports (color:color-mix(in lab, red, red)) {
        .bg-white\\/90 {
            background-color: color-mix(in oklab, var(--color-white) 90%, transparent)
        }
    }
    .bg-gradient-to-b {
        --tw-gradient-position: to bottom in oklab;
        background-image: linear-gradient(var(--tw-gradient-stops))
    }
    .bg-gradient-to-br {
        --tw-gradient-position: to bottom right in oklab;
        background-image: linear-gradient(var(--tw-gradient-stops))
    }
    .from-primary-50 {
        --tw-gradient-from: #fffbeb;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .from-primary-400 {
        --tw-gradient-from: #fbbf24;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .from-primary-600 {
        --tw-gradient-from: #d97706;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .to-primary-600 {
        --tw-gradient-to: #d97706;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .to-primary-700 {
        --tw-gradient-to: #b45309;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .to-primary-800 {
        --tw-gradient-to: #92400e;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .to-white {
        --tw-gradient-to: var(--color-white);
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .object-contain {
        object-fit: contain
    }
    .object-cover {
        object-fit: cover
    }
    .p-2 {
        padding: calc(var(--spacing) * 2)
    }
    .p-2\\.5 {
        padding: calc(var(--spacing) * 2.5)
    }
    .p-3 {
        padding: calc(var(--spacing) * 3)
    }
    .p-4 {
        padding: calc(var(--spacing) * 4)
    }
    .p-5 {
        padding: calc(var(--spacing) * 5)
    }
    .p-6 {
        padding: calc(var(--spacing) * 6)
    }
    .p-8 {
        padding: calc(var(--spacing) * 8)
    }
    .px-2 {
        padding-inline: calc(var(--spacing) * 2)
    }
    .px-2\\.5 {
        padding-inline: calc(var(--spacing) * 2.5)
    }
    .px-3 {
        padding-inline: calc(var(--spacing) * 3)
    }
    .px-4 {
        padding-inline: calc(var(--spacing) * 4)
    }
    .px-5 {
        padding-inline: calc(var(--spacing) * 5)
    }
    .px-6 {
        padding-inline: calc(var(--spacing) * 6)
    }
    .px-8 {
        padding-inline: calc(var(--spacing) * 8)
    }
    .py-0\\.5 {
        padding-block: calc(var(--spacing) * .5)
    }
    .py-1 {
        padding-block: calc(var(--spacing) * 1)
    }
    .py-1\\.5 {
        padding-block: calc(var(--spacing) * 1.5)
    }
    .py-2 {
        padding-block: calc(var(--spacing) * 2)
    }
    .py-2\\.5 {
        padding-block: calc(var(--spacing) * 2.5)
    }
    .py-3 {
        padding-block: calc(var(--spacing) * 3)
    }
    .py-4 {
        padding-block: calc(var(--spacing) * 4)
    }
    .py-6 {
        padding-block: calc(var(--spacing) * 6)
    }
    .py-8 {
        padding-block: calc(var(--spacing) * 8)
    }
    .py-16 {
        padding-block: calc(var(--spacing) * 16)
    }
    .py-20 {
        padding-block: calc(var(--spacing) * 20)
    }
    .pt-2 {
        padding-top: calc(var(--spacing) * 2)
    }
    .pt-4 {
        padding-top: calc(var(--spacing) * 4)
    }
    .pt-8 {
        padding-top: calc(var(--spacing) * 8)
    }
    .pt-10 {
        padding-top: calc(var(--spacing) * 10)
    }
    .pt-16 {
        padding-top: calc(var(--spacing) * 16)
    }
    .pr-4 {
        padding-right: calc(var(--spacing) * 4)
    }
    .pb-8 {
        padding-bottom: calc(var(--spacing) * 8)
    }
    .pl-4 {
        padding-left: calc(var(--spacing) * 4)
    }
    .pl-5 {
        padding-left: calc(var(--spacing) * 5)
    }
    .pl-6 {
        padding-left: calc(var(--spacing) * 6)
    }
    .pl-12 {
        padding-left: calc(var(--spacing) * 12)
    }
    .text-center {
        text-align: center
    }
    .text-left {
        text-align: left
    }
    .text-2xl {
        font-size: var(--text-2xl);
        line-height: var(--tw-leading, var(--text-2xl--line-height))
    }
    .text-3xl {
        font-size: var(--text-3xl);
        line-height: var(--tw-leading, var(--text-3xl--line-height))
    }
    .text-4xl {
        font-size: var(--text-4xl);
        line-height: var(--tw-leading, var(--text-4xl--line-height))
    }
    .text-5xl {
        font-size: var(--text-5xl);
        line-height: var(--tw-leading, var(--text-5xl--line-height))
    }
    .text-8xl {
        font-size: var(--text-8xl);
        line-height: var(--tw-leading, var(--text-8xl--line-height))
    }
    .text-base {
        font-size: var(--text-base);
        line-height: var(--tw-leading, var(--text-base--line-height))
    }
    .text-lg {
        font-size: var(--text-lg);
        line-height: var(--tw-leading, var(--text-lg--line-height))
    }
    .text-sm {
        font-size: var(--text-sm);
        line-height: var(--tw-leading, var(--text-sm--line-height))
    }
    .text-xl {
        font-size: var(--text-xl);
        line-height: var(--tw-leading, var(--text-xl--line-height))
    }
    .text-xs {
        font-size: var(--text-xs);
        line-height: var(--tw-leading, var(--text-xs--line-height))
    }
    .leading-relaxed {
        --tw-leading: var(--leading-relaxed);
        line-height: var(--leading-relaxed)
    }
    .font-bold {
        --tw-font-weight: var(--font-weight-bold);
        font-weight: var(--font-weight-bold)
    }
    .font-medium {
        --tw-font-weight: var(--font-weight-medium);
        font-weight: var(--font-weight-medium)
    }
    .font-normal {
        --tw-font-weight: var(--font-weight-normal);
        font-weight: var(--font-weight-normal)
    }
    .font-semibold {
        --tw-font-weight: var(--font-weight-semibold);
        font-weight: var(--font-weight-semibold)
    }
    .tracking-tight {
        --tw-tracking: var(--tracking-tight);
        letter-spacing: var(--tracking-tight)
    }
    .tracking-wider {
        --tw-tracking: var(--tracking-wider);
        letter-spacing: var(--tracking-wider)
    }
    .text-amber-600 {
        color: var(--color-amber-600)
    }
    .text-amber-700 {
        color: var(--color-amber-700)
    }
    .text-amber-800 {
        color: var(--color-amber-800)
    }
    .text-blue-600 {
        color: var(--color-blue-600)
    }
    .text-blue-700 {
        color: var(--color-blue-700)
    }
    .text-blue-800 {
        color: var(--color-blue-800)
    }
    .text-gray-50 {
        color: #f9fafb
    }
    .text-gray-300 {
        color: #d1d5db
    }
    .text-gray-400 {
        color: #9ca3af
    }
    .text-gray-500 {
        color: #6b7280
    }
    .text-gray-600 {
        color: #4b5563
    }
    .text-gray-700 {
        color: #374151
    }
    .text-gray-900 {
        color: #111827
    }
    .text-green-500 {
        color: var(--color-green-500)
    }
    .text-green-600 {
        color: var(--color-green-600)
    }
    .text-green-700 {
        color: var(--color-green-700)
    }
    .text-green-800 {
        color: var(--color-green-800)
    }
    .text-primary-100 {
        color: #fef3c7
    }
    .text-primary-200 {
        color: #fde68a
    }
    .text-primary-400 {
        color: #fbbf24
    }
    .text-primary-500 {
        color: #f59e0b
    }
    .text-primary-500\\/20 {
        color: #f59e0b33
    }
    .text-primary-600 {
        color: #d97706
    }
    .text-primary-700 {
        color: #b45309
    }
    .text-red-500 {
        color: var(--color-red-500)
    }
    .text-red-600 {
        color: var(--color-red-600)
    }
    .text-red-700 {
        color: var(--color-red-700)
    }
    .text-red-800 {
        color: var(--color-red-800)
    }
    .text-white {
        color: var(--color-white)
    }
    .lowercase {
        text-transform: lowercase
    }
    .uppercase {
        text-transform: uppercase
    }
    .italic {
        font-style: italic
    }
    .not-italic {
        font-style: normal
    }
    .placeholder-gray-400::placeholder {
        color: #9ca3af
    }
    .placeholder-gray-500::placeholder {
        color: #6b7280
    }
    .opacity-0 {
        opacity: 0
    }
    .opacity-10 {
        opacity: .1
    }
    .opacity-50 {
        opacity: .5
    }
    .opacity-75 {
        opacity: .75
    }
    .shadow {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, #0000001a), 0 1px 2px -1px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-2xl {
        --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, #00000040);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-lg {
        --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, #0000001a), 0 4px 6px -4px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-md {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, #0000001a), 0 2px 4px -2px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-sm {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, #0000001a), 0 1px 2px -1px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-soft {
        --tw-shadow: 0 4px 16px -4px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-xl {
        --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, #0000001a), 0 8px 10px -6px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .ring-1 {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .ring-2 {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .shadow-primary-600\\/25 {
        --tw-shadow-color: #d9770640
    }
    @supports (color:color-mix(in lab, red, red)) {
        .shadow-primary-600\\/25 {
            --tw-shadow-color: color-mix(in oklab, oklab(66.584% .082678 .133963/.25) var(--tw-shadow-alpha), transparent)
        }
    }
    .ring-gray-200 {
        --tw-ring-color: #e5e7eb
    }
    .ring-primary-100 {
        --tw-ring-color: #fef3c7
    }
    .ring-primary-600 {
        --tw-ring-color: #d97706
    }
    .outline {
        outline-style: var(--tw-outline-style);
        outline-width: 1px
    }
    .blur {
        --tw-blur: blur(8px);
        filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, )
    }
    .blur-3xl {
        --tw-blur: blur(var(--blur-3xl));
        filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, )
    }
    .brightness-0 {
        --tw-brightness: brightness(0%);
        filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, )
    }
    .invert {
        --tw-invert: invert(100%);
        filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, )
    }
    .filter {
        filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, )
    }
    .backdrop-blur-lg {
        --tw-backdrop-blur: blur(var(--blur-lg));
        -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
        backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, )
    }
    .backdrop-blur-sm {
        --tw-backdrop-blur: blur(var(--blur-sm));
        -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
        backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, )
    }
    .transition {
        transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .transition-all {
        transition-property: all;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .transition-colors {
        transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .transition-opacity {
        transition-property: opacity;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .transition-shadow {
        transition-property: box-shadow;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .transition-transform {
        transition-property: transform, translate, scale, rotate;
        transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
        transition-duration: var(--tw-duration, var(--default-transition-duration))
    }
    .transition-none {
        transition-property: none
    }
    .duration-200 {
        --tw-duration: .2s;
        transition-duration: .2s
    }
    .duration-300 {
        --tw-duration: .3s;
        transition-duration: .3s
    }
    .duration-500 {
        --tw-duration: .5s;
        transition-duration: .5s
    }
    .ease-out {
        --tw-ease: var(--ease-out);
        transition-timing-function: var(--ease-out)
    }
    @media(hover:hover) {
        .group-hover\\:visible:is(:where(.group): hover *) {
            visibility:visible
        }
        .group-hover\\:scale-105:is(:where(.group):hover *) {
            --tw-scale-x: 105%;
            --tw-scale-y: 105%;
            --tw-scale-z: 105%;
            scale: var(--tw-scale-x) var(--tw-scale-y)
        }
        .group-hover\\:rotate-180:is(:where(.group):hover *) {
            rotate: 180deg
        }
        .group-hover\\:bg-primary-600:is(:where(.group):hover *) {
            background-color: #d97706
        }
        .group-hover\\:text-primary-600:is(:where(.group):hover *) {
            color: #d97706
        }
        .group-hover\\:text-white:is(:where(.group):hover *) {
            color: var(--color-white)
        }
        .group-hover\\:opacity-100:is(:where(.group):hover *) {
            opacity: 1
        }
    }
    .peer-checked\\:translate-x-5:is(:where(.peer):checked~*) {
        --tw-translate-x: calc(var(--spacing) * 5);
        translate: var(--tw-translate-x) var(--tw-translate-y)
    }
    .peer-checked\\:bg-primary-600:is(:where(.peer):checked~*) {
        background-color: #d97706
    }
    .peer-focus\\:ring-2:is(:where(.peer):focus~*) {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .peer-focus\\:ring-primary-500\\/20:is(:where(.peer):focus~*) {
        --tw-ring-color: oklab(76.8591% .0560995 .154808/.2)
    }
    .placeholder\\:text-gray-400::placeholder {
        color: #9ca3af
    }
    .placeholder\\:text-gray-500::placeholder {
        color: #6b7280
    }
    @media(hover:hover) {
        .hover\\:border-primary-200:hover {
            border-color: #fde68a
        }
        .hover\\:border-white:hover {
            border-color: var(--color-white)
        }
        .hover\\:bg-\\[\\#0A66C2\\]:hover {
            background-color: #0a66c2
        }
        .hover\\:bg-\\[\\#1DA1F2\\]:hover {
            background-color: #1da1f2
        }
        .hover\\:bg-\\[\\#1877F2\\]:hover {
            background-color: #1877f2
        }
        .hover\\:bg-gray-50:hover {
            background-color: #f9fafb
        }
        .hover\\:bg-gray-100:hover {
            background-color: #f3f4f6
        }
        .hover\\:bg-gray-200:hover {
            background-color: #e5e7eb
        }
        .hover\\:bg-gray-300:hover {
            background-color: #d1d5db
        }
        .hover\\:bg-gray-700:hover {
            background-color: #374151
        }
        .hover\\:bg-primary-50:hover {
            background-color: #fffbeb
        }
        .hover\\:bg-primary-700:hover {
            background-color: #b45309
        }
        .hover\\:bg-white\\/10:hover {
            background-color: #ffffff1a
        }
        @supports (color:color-mix(in lab, red, red)) {
            .hover\\:bg-white\\/10:hover {
                background-color: color-mix(in oklab, var(--color-white) 10%, transparent)
            }
        }
        .hover\\:bg-white\\/20:hover {
            background-color: #fff3
        }
        @supports (color:color-mix(in lab, red, red)) {
            .hover\\:bg-white\\/20:hover {
                background-color: color-mix(in oklab, var(--color-white) 20%, transparent)
            }
        }
        .hover\\:text-gray-300:hover {
            color: #d1d5db
        }
        .hover\\:text-gray-700:hover {
            color: #374151
        }
        .hover\\:text-gray-900:hover {
            color: #111827
        }
        .hover\\:text-primary-600:hover {
            color: #d97706
        }
        .hover\\:text-primary-700:hover {
            color: #b45309
        }
        .hover\\:text-white:hover {
            color: var(--color-white)
        }
        .hover\\:shadow-lg:hover {
            --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, #0000001a), 0 4px 6px -4px var(--tw-shadow-color, #0000001a);
            box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
        }
        .hover\\:shadow-md:hover {
            --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, #0000001a), 0 2px 4px -2px var(--tw-shadow-color, #0000001a);
            box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
        }
        .hover\\:shadow-soft-lg:hover {
            --tw-shadow: 0 12px 32px -8px var(--tw-shadow-color, #00000024);
            box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
        }
        .hover\\:shadow-xl:hover {
            --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, #0000001a), 0 8px 10px -6px var(--tw-shadow-color, #0000001a);
            box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
        }
        .hover\\:shadow-primary-600\\/30:hover {
            --tw-shadow-color: #d977064d
        }
        @supports (color:color-mix(in lab, red, red)) {
            .hover\\:shadow-primary-600\\/30:hover {
                --tw-shadow-color: color-mix(in oklab, oklab(66.584% .082678 .133963/.3) var(--tw-shadow-alpha), transparent)
            }
        }
    }
    .focus\\:not-sr-only:focus {
        clip-path: none;
        white-space: normal;
        width: auto;
        height: auto;
        margin: 0;
        padding: 0;
        position: static;
        overflow: visible
    }
    .focus\\:fixed:focus {
        position: fixed
    }
    .focus\\:top-4:focus {
        top: calc(var(--spacing) * 4)
    }
    .focus\\:left-4:focus {
        left: calc(var(--spacing) * 4)
    }
    .focus\\:z-\\[80\\]:focus {
        z-index: 80
    }
    .focus\\:rounded-lg:focus {
        border-radius: var(--radius-lg)
    }
    .focus\\:border-primary-500:focus {
        border-color: #f59e0b
    }
    .focus\\:bg-primary-600:focus {
        background-color: #d97706
    }
    .focus\\:px-4:focus {
        padding-inline: calc(var(--spacing) * 4)
    }
    .focus\\:py-2:focus {
        padding-block: calc(var(--spacing) * 2)
    }
    .focus\\:text-sm:focus {
        font-size: var(--text-sm);
        line-height: var(--tw-leading, var(--text-sm--line-height))
    }
    .focus\\:font-medium:focus {
        --tw-font-weight: var(--font-weight-medium);
        font-weight: var(--font-weight-medium)
    }
    .focus\\:text-white:focus {
        color: var(--color-white)
    }
    .focus\\:shadow-lg:focus {
        --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, #0000001a), 0 4px 6px -4px var(--tw-shadow-color, #0000001a);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .focus\\:ring-1:focus {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .focus\\:ring-2:focus {
        --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)
    }
    .focus\\:ring-primary-500:focus {
        --tw-ring-color: #f59e0b
    }
    .focus\\:ring-primary-500\\/20:focus {
        --tw-ring-color: oklab(76.8591% .0560995 .154808/.2)
    }
    .focus\\:ring-offset-2:focus {
        --tw-ring-offset-width: 2px;
        --tw-ring-offset-shadow: var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)
    }
    .focus\\:outline-none:focus {
        --tw-outline-style: none;
        outline-style: none
    }
    @media(min-width:40rem) {
        .sm\\:inline-flex {
            display: inline-flex
        }
        .sm\\:h-64 {
            height: calc(var(--spacing) * 64)
        }
        .sm\\:w-auto {
            width: auto
        }
        .sm\\:grid-cols-2 {
            grid-template-columns: repeat(2, minmax(0, 1fr))
        }
        .sm\\:grid-cols-3 {
            grid-template-columns: repeat(3, minmax(0, 1fr))
        }
        .sm\\:grid-cols-4 {
            grid-template-columns: repeat(4, minmax(0, 1fr))
        }
        .sm\\:flex-row {
            flex-direction: row
        }
        .sm\\:p-6 {
            padding: calc(var(--spacing) * 6)
        }
        .sm\\:text-2xl {
            font-size: var(--text-2xl);
            line-height: var(--tw-leading, var(--text-2xl--line-height))
        }
        .sm\\:text-3xl {
            font-size: var(--text-3xl);
            line-height: var(--tw-leading, var(--text-3xl--line-height))
        }
        .sm\\:text-4xl {
            font-size: var(--text-4xl);
            line-height: var(--tw-leading, var(--text-4xl--line-height))
        }
        .sm\\:text-5xl {
            font-size: var(--text-5xl);
            line-height: var(--tw-leading, var(--text-5xl--line-height))
        }
        .sm\\:text-lg {
            font-size: var(--text-lg);
            line-height: var(--tw-leading, var(--text-lg--line-height))
        }
        .sm\\:text-xl {
            font-size: var(--text-xl);
            line-height: var(--tw-leading, var(--text-xl--line-height))
        }
    }
    @media(min-width:64rem) {
        .lg\\:order-first {
            order: -9999
        }
        .lg\\:col-span-2 {
            grid-column: span 2/span 2
        }
        .lg\\:col-span-3 {
            grid-column: span 3/span 3
        }
        .lg\\:col-span-4 {
            grid-column: span 4/span 4
        }
        .lg\\:col-span-5 {
            grid-column: span 5/span 5
        }
        .lg\\:mt-24 {
            margin-top: calc(var(--spacing) * 24)
        }
        .lg\\:flex {
            display: flex
        }
        .lg\\:hidden {
            display: none
        }
        .lg\\:h-10 {
            height: calc(var(--spacing) * 10)
        }
        .lg\\:h-20 {
            height: calc(var(--spacing) * 20)
        }
        .lg\\:grid-cols-2 {
            grid-template-columns: repeat(2, minmax(0, 1fr))
        }
        .lg\\:grid-cols-3 {
            grid-template-columns: repeat(3, minmax(0, 1fr))
        }
        .lg\\:grid-cols-4 {
            grid-template-columns: repeat(4, minmax(0, 1fr))
        }
        .lg\\:grid-cols-5 {
            grid-template-columns: repeat(5, minmax(0, 1fr))
        }
        .lg\\:grid-cols-12 {
            grid-template-columns: repeat(12, minmax(0, 1fr))
        }
        .lg\\:items-center {
            align-items: center
        }
        .lg\\:gap-8 {
            gap: calc(var(--spacing) * 8)
        }
        .lg\\:p-8 {
            padding: calc(var(--spacing) * 8)
        }
        .lg\\:px-8 {
            padding-inline: calc(var(--spacing) * 8)
        }
        .lg\\:py-12 {
            padding-block: calc(var(--spacing) * 12)
        }
        .lg\\:py-20 {
            padding-block: calc(var(--spacing) * 20)
        }
        .lg\\:py-24 {
            padding-block: calc(var(--spacing) * 24)
        }
        .lg\\:py-28 {
            padding-block: calc(var(--spacing) * 28)
        }
        .lg\\:py-32 {
            padding-block: calc(var(--spacing) * 32)
        }
        .lg\\:pt-24 {
            padding-top: calc(var(--spacing) * 24)
        }
        .lg\\:text-4xl {
            font-size: var(--text-4xl);
            line-height: var(--tw-leading, var(--text-4xl--line-height))
        }
        .lg\\:text-5xl {
            font-size: var(--text-5xl);
            line-height: var(--tw-leading, var(--text-5xl--line-height))
        }
        .lg\\:text-6xl {
            font-size: var(--text-6xl);
            line-height: var(--tw-leading, var(--text-6xl--line-height))
        }
        .lg\\:text-9xl {
            font-size: var(--text-9xl);
            line-height: var(--tw-leading, var(--text-9xl--line-height))
        }
    }
    .dark\\:block:is(.dark *) {
        display: block
    }
    .dark\\:hidden:is(.dark *) {
        display: none
    }
    :where(.dark\\:divide-gray-800:is(.dark *)>:not(:last-child)) {
        border-color: #1f2937
    }
    .dark\\:border-gray-600:is(.dark *) {
        border-color: #4b5563
    }
    .dark\\:border-gray-700:is(.dark *) {
        border-color: #374151
    }
    .dark\\:border-gray-800:is(.dark *) {
        border-color: #1f2937
    }
    .dark\\:border-primary-400:is(.dark *) {
        border-color: #fbbf24
    }
    .dark\\:border-primary-800:is(.dark *) {
        border-color: #92400e
    }
    .dark\\:border-t-primary-400:is(.dark *) {
        border-top-color: #fbbf24
    }
    .dark\\:bg-amber-900\\/20:is(.dark *) {
        background-color: #7b330633
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-amber-900\\/20:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-amber-900) 20%, transparent)
        }
    }
    .dark\\:bg-amber-900\\/50:is(.dark *) {
        background-color: #7b330680
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-amber-900\\/50:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-amber-900) 50%, transparent)
        }
    }
    .dark\\:bg-blue-900\\/20:is(.dark *) {
        background-color: #1c398e33
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-blue-900\\/20:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-blue-900) 20%, transparent)
        }
    }
    .dark\\:bg-blue-900\\/50:is(.dark *) {
        background-color: #1c398e80
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-blue-900\\/50:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-blue-900) 50%, transparent)
        }
    }
    .dark\\:bg-gray-600:is(.dark *) {
        background-color: #4b5563
    }
    .dark\\:bg-gray-700:is(.dark *) {
        background-color: #374151
    }
    .dark\\:bg-gray-800:is(.dark *) {
        background-color: #1f2937
    }
    .dark\\:bg-gray-800\\/30:is(.dark *) {
        background-color: #1f29374d
    }
    .dark\\:bg-gray-800\\/50:is(.dark *) {
        background-color: #1f293780
    }
    .dark\\:bg-gray-900:is(.dark *) {
        background-color: #111827
    }
    .dark\\:bg-gray-900\\/90:is(.dark *) {
        background-color: #111827e6
    }
    .dark\\:bg-gray-950:is(.dark *) {
        background-color: #030712
    }
    .dark\\:bg-gray-950\\/80:is(.dark *) {
        background-color: #030712cc
    }
    .dark\\:bg-green-900\\/20:is(.dark *) {
        background-color: #0d542b33
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-green-900\\/20:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-green-900) 20%, transparent)
        }
    }
    .dark\\:bg-green-900\\/50:is(.dark *) {
        background-color: #0d542b80
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-green-900\\/50:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-green-900) 50%, transparent)
        }
    }
    .dark\\:bg-primary-400:is(.dark *) {
        background-color: #fbbf24
    }
    .dark\\:bg-primary-800\\/20:is(.dark *) {
        background-color: #92400e33
    }
    .dark\\:bg-primary-900:is(.dark *) {
        background-color: #78350f
    }
    .dark\\:bg-primary-900\\/30:is(.dark *) {
        background-color: #78350f4d
    }
    .dark\\:bg-primary-900\\/50:is(.dark *) {
        background-color: #78350f80
    }
    .dark\\:bg-red-900\\/20:is(.dark *) {
        background-color: #82181a33
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-red-900\\/20:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-red-900) 20%, transparent)
        }
    }
    .dark\\:bg-red-900\\/50:is(.dark *) {
        background-color: #82181a80
    }
    @supports (color:color-mix(in lab, red, red)) {
        .dark\\:bg-red-900\\/50:is(.dark *) {
            background-color: color-mix(in oklab, var(--color-red-900) 50%, transparent)
        }
    }
    .dark\\:from-gray-900:is(.dark *) {
        --tw-gradient-from: #111827;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .dark\\:from-primary-900:is(.dark *) {
        --tw-gradient-from: #78350f;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .dark\\:to-gray-950:is(.dark *) {
        --tw-gradient-to: #030712;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position))
    }
    .dark\\:text-amber-300:is(.dark *) {
        color: var(--color-amber-300)
    }
    .dark\\:text-amber-400:is(.dark *) {
        color: var(--color-amber-400)
    }
    .dark\\:text-blue-300:is(.dark *) {
        color: var(--color-blue-300)
    }
    .dark\\:text-blue-400:is(.dark *) {
        color: var(--color-blue-400)
    }
    .dark\\:text-gray-300:is(.dark *) {
        color: #d1d5db
    }
    .dark\\:text-gray-400:is(.dark *) {
        color: #9ca3af
    }
    .dark\\:text-gray-500:is(.dark *) {
        color: #6b7280
    }
    .dark\\:text-gray-600:is(.dark *) {
        color: #4b5563
    }
    .dark\\:text-gray-900:is(.dark *) {
        color: #111827
    }
    .dark\\:text-green-300:is(.dark *) {
        color: var(--color-green-300)
    }
    .dark\\:text-green-400:is(.dark *) {
        color: var(--color-green-400)
    }
    .dark\\:text-primary-300:is(.dark *) {
        color: #fcd34d
    }
    .dark\\:text-primary-400:is(.dark *) {
        color: #fbbf24
    }
    .dark\\:text-red-300:is(.dark *) {
        color: var(--color-red-300)
    }
    .dark\\:text-red-400:is(.dark *) {
        color: var(--color-red-400)
    }
    .dark\\:text-white:is(.dark *) {
        color: var(--color-white)
    }
    .dark\\:placeholder-gray-500:is(.dark *)::placeholder {
        color: #6b7280
    }
    .dark\\:ring-gray-800:is(.dark *) {
        --tw-ring-color: #1f2937
    }
    .dark\\:ring-primary-900:is(.dark *) {
        --tw-ring-color: #78350f
    }
    @media(hover:hover) {
        .dark\\:group-hover\\:text-primary-400:is(.dark *):is(:where(.group): hover *) {
            color:#fbbf24
        }
    }
    .dark\\:placeholder\\:text-gray-500:is(.dark *)::placeholder {
        color: #6b7280
    }
    @media(hover:hover) {
        .dark\\:hover\\:border-primary-800:is(.dark *):hover {
            border-color: #92400e
        }
        .dark\\:hover\\:bg-gray-600:is(.dark *):hover {
            background-color: #4b5563
        }
        .dark\\:hover\\:bg-gray-700:is(.dark *):hover {
            background-color: #374151
        }
        .dark\\:hover\\:bg-gray-800:is(.dark *):hover {
            background-color: #1f2937
        }
        .dark\\:hover\\:text-gray-300:is(.dark *):hover {
            color: #d1d5db
        }
        .dark\\:hover\\:text-primary-300:is(.dark *):hover {
            color: #fcd34d
        }
        .dark\\:hover\\:text-primary-400:is(.dark *):hover {
            color: #fbbf24
        }
        .dark\\:hover\\:text-white:is(.dark *):hover {
            color: var(--color-white)
        }
    }
    .dark\\:focus\\:border-primary-400:is(.dark *):focus {
        border-color: #fbbf24
    }
    .dark\\:focus\\:ring-primary-400\\/20:is(.dark *):focus {
        --tw-ring-color: oklab(83.6861% .0159629 .163645/.2)
    }
    .text-gradient {
        --tw-gradient-position: to right in oklab;
        background-image: linear-gradient(var(--tw-gradient-stops));
        --tw-gradient-from: #d97706;
        --tw-gradient-to: #fbbf24;
        --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
        color: #0000;
        -webkit-background-clip: text;
        background-clip: text
    }
    .delay-100 {
        animation-delay: .1s
    }
    .delay-200 {
        animation-delay: .2s
    }
    .delay-300 {
        animation-delay: .3s
    }
    .delay-400 {
        animation-delay: .4s
    }
    .delay-500 {
        animation-delay: .5s
    }
}

@keyframes hero-float {
    0%,
    to {
        transform: translate(0)scale(1)
    }
    33% {
        transform: translate(30px, -20px)scale(1.05)
    }
    66% {
        transform: translate(-20px, 15px)scale(.95)
    }
}

.animate-hero-float {
    animation: 8s ease-in-out infinite hero-float
}

.animate-hero-float-reverse {
    animation: 10s ease-in-out infinite reverse hero-float
}

@keyframes shimmer {
    0% {
        background-position: -200% 0
    }
    to {
        background-position: 200% 0
    }
}

.img-shimmer {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0, #f0f0f0 75%) 0 0/200% 100%;
    animation: 1.5s ease-in-out infinite shimmer
}

.dark .img-shimmer {
    background: linear-gradient(90deg, #1f2937 25%, #374151, #1f2937 75%) 0 0/200% 100%
}

[data-nav-link].nav-active {
    color: #111827;
    font-weight: 600
}

.dark [data-nav-link].nav-active {
    color: #fff
}

.prose {
    --tw-prose-body: #4b5563;
    --tw-prose-headings: #111827;
    --tw-prose-links: #d97706;
    --tw-prose-bold: #111827;
    --tw-prose-code: #111827;
    --tw-prose-pre-bg: #111827;
    --tw-prose-pre-code: #e5e7eb;
    color: var(--tw-prose-body);
    max-width: 65ch;
    font-size: 1rem;
    line-height: 1.75
}

.prose h1,
.prose h2,
.prose h3,
.prose h4 {
    color: var(--tw-prose-headings);
    margin-top: 2em;
    margin-bottom: .75em;
    font-weight: 700;
    line-height: 1.25
}

.prose h1 {
    margin-top: 0;
    font-size: 2.25em
}

.prose h2 {
    font-size: 1.5em
}

.prose h3 {
    font-size: 1.25em
}

.prose p {
    margin-top: 1.25em;
    margin-bottom: 1.25em
}

.prose a {
    color: var(--tw-prose-links);
    font-weight: 500;
    text-decoration: underline
}

.prose a:hover {
    color: #b45309
}

.prose strong {
    color: var(--tw-prose-bold);
    font-weight: 600
}

.prose ul,
.prose ol {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
    padding-left: 1.625em
}

.prose li {
    margin-top: .5em;
    margin-bottom: .5em
}

.prose ul>li {
    list-style-type: disc
}

.prose ol>li {
    list-style-type: decimal
}

.prose code {
    color: var(--tw-prose-code);
    font-size: .875em;
    font-weight: 600
}
/*
.prose code:before,
.prose code:after {
    content: "BACKTICKHERE"
}
*/

.prose pre {
    background-color: var(--tw-prose-pre-bg);
    color: var(--tw-prose-pre-code);
    border-radius: .5rem;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
    padding: 1rem 1.25rem;
    font-size: .875em;
    line-height: 1.7;
    overflow-x: auto
}

.prose pre code {
    font-weight: inherit;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    background-color: #0000;
    border-width: 0;
    border-radius: 0;
    padding: 0
}

.prose pre code:before,
.prose pre code:after {
    content: none
}

.prose blockquote {
    border-left: 4px solid #d1d5db;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
    padding-left: 1em;
    font-style: italic
}

.prose img {
    border-radius: .75rem;
    margin-top: 2em;
    margin-bottom: 2em
}

.prose hr {
    border-color: #e5e7eb;
    margin-top: 3em;
    margin-bottom: 3em
}

.dark .prose,
.prose-invert {
    --tw-prose-body: #d1d5db;
    --tw-prose-headings: #fff;
    --tw-prose-links: #fbbf24;
    --tw-prose-bold: #fff;
    --tw-prose-code: #fff
}

.dark .prose a:hover {
    color: #fcd34d
}

.dark .prose blockquote {
    border-left-color: #374151
}

.dark .prose hr {
    border-color: #1f2937
}

@property --tw-translate-x {
    syntax: "*";
    inherits: false;
    initial-value: 0
}

@property --tw-translate-y {
    syntax: "*";
    inherits: false;
    initial-value: 0
}

@property --tw-translate-z {
    syntax: "*";
    inherits: false;
    initial-value: 0
}

@property --tw-rotate-x {
    syntax: "*";
    inherits: false
}

@property --tw-rotate-y {
    syntax: "*";
    inherits: false
}

@property --tw-rotate-z {
    syntax: "*";
    inherits: false
}

@property --tw-skew-x {
    syntax: "*";
    inherits: false
}

@property --tw-skew-y {
    syntax: "*";
    inherits: false
}

@property --tw-space-y-reverse {
    syntax: "*";
    inherits: false;
    initial-value: 0
}

@property --tw-divide-y-reverse {
    syntax: "*";
    inherits: false;
    initial-value: 0
}

@property --tw-border-style {
    syntax: "*";
    inherits: false;
    initial-value: solid
}

@property --tw-gradient-position {
    syntax: "*";
    inherits: false
}

@property --tw-gradient-from {
    syntax: "<color>";
    inherits: false;
    initial-value: #0000
}

@property --tw-gradient-via {
    syntax: "<color>";
    inherits: false;
    initial-value: #0000
}

@property --tw-gradient-to {
    syntax: "<color>";
    inherits: false;
    initial-value: #0000
}

@property --tw-gradient-stops {
    syntax: "*";
    inherits: false
}

@property --tw-gradient-via-stops {
    syntax: "*";
    inherits: false
}

@property --tw-gradient-from-position {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 0%
}

@property --tw-gradient-via-position {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 50%
}

@property --tw-gradient-to-position {
    syntax: "<length-percentage>";
    inherits: false;
    initial-value: 100%
}

@property --tw-leading {
    syntax: "*";
    inherits: false
}

@property --tw-font-weight {
    syntax: "*";
    inherits: false
}

@property --tw-tracking {
    syntax: "*";
    inherits: false
}

@property --tw-shadow {
    syntax: "*";
    inherits: false;
    initial-value: 0 0 #0000
}

@property --tw-shadow-color {
    syntax: "*";
    inherits: false
}

@property --tw-shadow-alpha {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 100%
}

@property --tw-inset-shadow {
    syntax: "*";
    inherits: false;
    initial-value: 0 0 #0000
}

@property --tw-inset-shadow-color {
    syntax: "*";
    inherits: false
}

@property --tw-inset-shadow-alpha {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 100%
}

@property --tw-ring-color {
    syntax: "*";
    inherits: false
}

@property --tw-ring-shadow {
    syntax: "*";
    inherits: false;
    initial-value: 0 0 #0000
}

@property --tw-inset-ring-color {
    syntax: "*";
    inherits: false
}

@property --tw-inset-ring-shadow {
    syntax: "*";
    inherits: false;
    initial-value: 0 0 #0000
}

@property --tw-ring-inset {
    syntax: "*";
    inherits: false
}

@property --tw-ring-offset-width {
    syntax: "<length>";
    inherits: false;
    initial-value: 0
}

@property --tw-ring-offset-color {
    syntax: "*";
    inherits: false;
    initial-value: #fff
}

@property --tw-ring-offset-shadow {
    syntax: "*";
    inherits: false;
    initial-value: 0 0 #0000
}

@property --tw-outline-style {
    syntax: "*";
    inherits: false;
    initial-value: solid
}

@property --tw-blur {
    syntax: "*";
    inherits: false
}

@property --tw-brightness {
    syntax: "*";
    inherits: false
}

@property --tw-contrast {
    syntax: "*";
    inherits: false
}

@property --tw-grayscale {
    syntax: "*";
    inherits: false
}

@property --tw-hue-rotate {
    syntax: "*";
    inherits: false
}

@property --tw-invert {
    syntax: "*";
    inherits: false
}

@property --tw-opacity {
    syntax: "*";
    inherits: false
}

@property --tw-saturate {
    syntax: "*";
    inherits: false
}

@property --tw-sepia {
    syntax: "*";
    inherits: false
}

@property --tw-drop-shadow {
    syntax: "*";
    inherits: false
}

@property --tw-drop-shadow-color {
    syntax: "*";
    inherits: false
}

@property --tw-drop-shadow-alpha {
    syntax: "<percentage>";
    inherits: false;
    initial-value: 100%
}

@property --tw-drop-shadow-size {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-blur {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-brightness {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-contrast {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-grayscale {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-hue-rotate {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-invert {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-opacity {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-saturate {
    syntax: "*";
    inherits: false
}

@property --tw-backdrop-sepia {
    syntax: "*";
    inherits: false
}

@property --tw-duration {
    syntax: "*";
    inherits: false
}

@property --tw-ease {
    syntax: "*";
    inherits: false
}

@property --tw-scale-x {
    syntax: "*";
    inherits: false;
    initial-value: 1
}

@property --tw-scale-y {
    syntax: "*";
    inherits: false;
    initial-value: 1
}

@property --tw-scale-z {
    syntax: "*";
    inherits: false;
    initial-value: 1
}

@keyframes spin {
    to {
        transform: rotate(360deg)
    }
}

@keyframes ping {
    75%,
    to {
        opacity: 0;
        transform: scale(2)
    }
}

.astro-route-announcer {
    position: absolute;
    left: 0;
    top: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    overflow: hidden;
    white-space: nowrap;
    width: 1px;
    height: 1px
}

`